var render = function render(){var _vm=this,_c=_vm._self._c;return _c('YMap',{staticClass:"h-100",attrs:{"settings":_vm.settings,"coords":_vm.value,"zoom":"15"},on:{"click":_vm.onMapClicked}},[_c('YMarker',{attrs:{"marker-type":"Placemark","marker-id":"place","coords":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }